module.exports = __webpack_public_path__ + "static/media/Ice Queen.95909ed6.jpg";